import { render, staticRenderFns } from "./right-therm-details.vue?vue&type=template&id=a50d5fa4&scoped=true"
import script from "./right-therm-details.vue?vue&type=script&lang=js"
export * from "./right-therm-details.vue?vue&type=script&lang=js"
import style0 from "./right-therm-details.vue?vue&type=style&index=0&id=a50d5fa4&prod&lang=scss&scoped=true"
import style1 from "./right-therm-details.vue?vue&type=style&index=1&id=a50d5fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50d5fa4",
  null
  
)

export default component.exports